var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}import React, { Component } from 'react';
import { createSelector } from 'reselect';

import { connect } from 'react-redux';

import { Translate } from "../I18N";
import { TableRows } from "./TableRows";






class TableViewerComponent extends Component {


  render() {
    const columns = this.props.columns.filter((c) => !c.hidden);
    return /*#__PURE__*/(
      _jsx("div", { className: "tableview-wrapper" }, void 0, /*#__PURE__*/
      _jsx("table", {}, void 0, /*#__PURE__*/
      _jsx("thead", {}, void 0, /*#__PURE__*/
      _jsx("tr", {}, void 0,
      columns.map((column, index) => /*#__PURE__*/
      _jsx("th", { className: !index ? 'sticky-col' : '' }, column.name, /*#__PURE__*/
      _jsx("div", { className: "table-view-cell" }, void 0, /*#__PURE__*/
      _jsx(Translate, { context: column.translationContext }, void 0, column.label)
      )
      )
      )
      )
      ), /*#__PURE__*/
      _jsx("tbody", {}, void 0, /*#__PURE__*/
      _jsx(TableRows, {
        columns: columns,
        clickOnDocument: this.props.clickOnDocument,
        storeKey: this.props.storeKey }
      )
      )
      )
      ));

  }
}_defineProperty(TableViewerComponent, "wrapLoader", true);

const getTableViewColumnsSelector = (state) => state.ui.get('tableViewColumns');
const selectTableViewColumns = createSelector(getTableViewColumnsSelector, (columns) =>
columns === null || columns === void 0 ? void 0 : columns.toJS()
);

const mapStateToProps = (state, props) => ({
  columns: selectTableViewColumns(state[props.storeKey])
});

export { selectTableViewColumns };


export const TableViewer = connect(mapStateToProps)(TableViewerComponent);